import { styled, css } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';

const navLinkActive = ({ theme, ...props }: any) =>
  props['data-active'] &&
  css`
    color: ${theme.colors.primary[40]};
  `;

export const NavItem = styled.li`
  display: flex;
  padding: 15px 0 15px 8px;
  list-style: none;
  width: 100%;
  align-items: center;
`;

export const NavLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  color: ${selectTheme('colors.neutral.90')};

  &:hover {
    color: ${selectTheme('colors.primary.40')};
    svg {
      g {
        path:not([d='M0,0h24v24h-24Z']) {
          stroke: #11bb77;
        }
      }
    }
  }

  ${navLinkActive}
`;

export const NavIcon = styled.span`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const navTextExpanded = ({ expanded = false }: { expanded?: boolean }) =>
  expanded &&
  css`
    opacity: 1;
  `;

export const NavText = styled.span`
  opacity: 0;
  transition: opacity 0.265s ease-out;
  transform: translateY(-3px);
  font-size: 16px;
  font-weight: 300;
  white-space: nowrap;
  ${navTextExpanded}
`;
